import { useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/store";
import {
  incrementCurrentContributionStep,
  decrementCurrentContributionStep,
} from "@/store/wizard";
import {
  ContributionState,
  ContributionManagementHookProps,
} from "../types/contributionTypes";

interface UseContributionManagementReturn extends ContributionState {
  currentContributionStep: number;
  handleStepNext: () => void;
  handleStepPrevious: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setIsSubmitting: (submitting: boolean) => void;
  setIsSuccess: (success: boolean) => void;
}

export const useContributionManagement = ({
  handleNext,
  handlePrevious,
}: ContributionManagementHookProps): UseContributionManagementReturn => {
  const dispatch = useDispatch();
  const { currentContributionStep } = useSelector(
    (state: RootState) => state.wizard
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState<boolean>(true);

  const handleStepNext = useCallback(() => {
    if (currentContributionStep === 1) {
      dispatch(incrementCurrentContributionStep());
    } else if (currentContributionStep === 2) {
      handleNext();
    }
  }, [currentContributionStep, dispatch, handleNext]);

  const handleStepPrevious = useCallback(() => {
    if (currentContributionStep === 2) {
      dispatch(decrementCurrentContributionStep());
    } else if (currentContributionStep === 1) {
      handlePrevious();
    }
  }, [currentContributionStep, dispatch, handlePrevious]);

  return {
    currentStep: currentContributionStep,
    currentContributionStep,
    loading,
    isSubmitting,
    error,
    isSuccess,
    handleStepNext,
    handleStepPrevious,
    setLoading,
    setError,
    setIsSubmitting,
    setIsSuccess,
  };
};
